import React from 'react';
import { SERVICE_CONTRACT_MODEL_OPTIONS } from '../serviceOptions';

const toneByIndex = [
  'border-cyan-200 bg-cyan-50/80 text-cyan-950',
  'border-violet-200 bg-violet-50/80 text-violet-950',
  'border-amber-200 bg-amber-50/80 text-amber-950',
];

export default function ServiceContractModesView() {
  return (
    <div className="space-y-5">
      <div className="rounded-[30px] border border-slate-200 bg-[linear-gradient(135deg,#ffffff_0%,#f8fafc_100%)] px-5 py-5 shadow-[0_14px_34px_rgba(15,23,42,0.06)]">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">Modos comerciales</p>
        <h3 className="mt-2 text-xl font-black tracking-tight text-slate-900">Cómo puede cobrar la empresa cada servicio</h3>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-500">
          Acá vamos a definir el tipo de acuerdo comercial de cada cliente. La liquidación del chofer sigue igual;
          lo que cambia es cómo la empresa transforma ese costo operativo en ingreso y ganancia.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        {SERVICE_CONTRACT_MODEL_OPTIONS.map((option, index) => (
          <div
            key={option.value}
            className={`rounded-[28px] border px-5 py-5 shadow-[0_14px_34px_rgba(15,23,42,0.06)] ${toneByIndex[index] || toneByIndex[0]}`}
          >
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] opacity-70">
              {index + 1}. Modelo
            </p>
            <p className="mt-2 text-xl font-black tracking-tight">{option.label}</p>
            <p className="mt-3 text-sm leading-6 opacity-80">{option.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
